// extracted by mini-css-extract-plugin
export default {"uploadTextContainer":"DropContent_uploadTextContainer__-ggVl","uploadText":"DropContent_uploadText__6WMcr","underline":"DropContent_underline__0A1pL"};